import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const PANE_NAME = 'likeMarkersPane';

export default function LikeMarkers({ likedTrailIds, mappedFeatures, isPersonal }) {
    const map = useMap();
    const layerRef = useRef(null);

    useEffect(() => {
        if (!map) return;

        // Crea pane dedicato con z-index sopra tutto (markerPane è 600)
        if (!map.getPane(PANE_NAME)) {
            const pane = map.createPane(PANE_NAME);
            pane.style.zIndex = 700;
            pane.style.pointerEvents = 'none';
        }

        if (!layerRef.current) {
            layerRef.current = L.layerGroup({ pane: PANE_NAME }).addTo(map);
        }

        const layer = layerRef.current;
        layer.clearLayers();

        if (!likedTrailIds || likedTrailIds.size === 0 || !mappedFeatures) return;

        const emoji = isPersonal ? '❤️' : '👍';
        let count = 0;

        likedTrailIds.forEach(trailId => {
            const trail = mappedFeatures.find(f =>
                f.id === trailId ||
                f.properties?.id === trailId ||
                String(f.id) === String(trailId) ||
                String(f.properties?.id) === String(trailId)
            );

            if (!trail) {
                console.warn('⚠️ Trail non trovato per id:', trailId,
                    '— esempi id disponibili:', mappedFeatures.slice(0, 3).map(f => ({ id: f.id, pid: f.properties?.id }))
                );
                return;
            }

            try {
                const coords = trail.geometry?.type === 'LineString'
                    ? trail.geometry.coordinates
                    : trail.geometry?.coordinates?.[0];
                if (!coords?.length) return;

                const mid = coords[Math.floor(coords.length / 2)];
                const [lng, lat] = mid;
                if (isNaN(lat) || isNaN(lng)) return;

                const icon = L.divIcon({
                    html: `<div style="
                        font-size: 28px;
                        line-height: 1;
                        width: 36px;
                        height: 36px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        filter: drop-shadow(0 1px 4px rgba(0,0,0,0.6));
                    ">${emoji}</div>`,
                    className: '',
                    iconSize: [36, 36],
                    iconAnchor: [18, 18],
                });

                L.marker([lat, lng], {
                    icon,
                    pane: PANE_NAME,
                    interactive: false,
                    zIndexOffset: 1000,
                }).addTo(layer);

                count++;
            } catch (e) {
                console.warn('⚠️ Errore like marker:', trailId, e);
            }
        });

        console.log(`❤️ LikeMarkers: ${count} marker aggiunti nel pane "${PANE_NAME}"`);

    }, [map, likedTrailIds, mappedFeatures, isPersonal]);

    useEffect(() => {
        return () => {
            if (layerRef.current && map) {
                layerRef.current.clearLayers();
                map.removeLayer(layerRef.current);
                layerRef.current = null;
            }
        };
    }, [map]);

    return null;
}